import React from 'react';
import { compose } from 'redux';
import {
  useTranslation,
  withTranslation,
  WithTranslation,
} from 'react-i18next';
import Zone from '@wix/da-gruser-shared/pkg/components/Zone';
import GruserContext from '@wix/da-gruser-shared/pkg/context/GruserContext';
import withSectionFetchSpinner from '../../../../decorators/withSectionFetchSpinner';
import { useDispatch, useSelector } from 'react-redux';
import { getShopWidgetConfigs } from '../shopWidgetConfigs';
import EmptyState from '../_partials/EmptyState';

import s from './ShopAll.scss';
import {
  getProfileGruser,
  getProfileOwnerUser,
} from '../../../../selectors/users';

export interface Props {
  className?: string;
  isEmpty?: boolean;
  isOwner?: boolean;
  hasSingularContentType?: boolean;
  emptySections?: Object;
}

const defaultProps = {};

const enhance = compose(withSectionFetchSpinner, withTranslation());

const ShopAll: React.FC<Props & WithTranslation> = ({
  isEmpty,
  isOwner,
  emptySections,
  hasSingularContentType,
  className,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const gruser = useSelector(getProfileGruser);
  const profileOwnerUser = useSelector(getProfileOwnerUser);

  const shopWidgetConfigs = getShopWidgetConfigs({ t, dispatch });

  if (isEmpty && !isOwner) {
    return <EmptyState view="large" />;
  }

  // deviation_gruser TODO:
  // if there is only one section and it's not empty, we want to expand it
  // to visitors to show more thumbs immediately
  // const expandOnlySection =
  //   !isOwner && hasSingularContentType && emptySections;

  return (
    <div className={className}>
      <GruserContext.Provider value={{ gruser, gruserOwner: profileOwnerUser }}>
        <Zone
          name="topBar"
          className={s['zone']}
          mapModuleTypeToWidgetConfig={shopWidgetConfigs}
        />
      </GruserContext.Provider>
    </div>
  );
};

ShopAll.defaultProps = defaultProps;

export default enhance(ShopAll);
